var CardsGalleryPlusTemplateType;
(function (CardsGalleryPlusTemplateType) {
    CardsGalleryPlusTemplateType["CLASSIC"] = "classic";
    CardsGalleryPlusTemplateType["FLOATING"] = "floating";
})(CardsGalleryPlusTemplateType || (CardsGalleryPlusTemplateType = {}));
var CardsGalleryPlusDisplayType;
(function (CardsGalleryPlusDisplayType) {
    CardsGalleryPlusDisplayType["CAROUSEL"] = "carousel";
    CardsGalleryPlusDisplayType["GRID"] = "grid";
})(CardsGalleryPlusDisplayType || (CardsGalleryPlusDisplayType = {}));
var CardsGalleryPlusHeadlineColor;
(function (CardsGalleryPlusHeadlineColor) {
    CardsGalleryPlusHeadlineColor["BLACK"] = "black";
    CardsGalleryPlusHeadlineColor["BURGUNDY"] = "burgundy";
    CardsGalleryPlusHeadlineColor["PURPLE"] = "purple";
})(CardsGalleryPlusHeadlineColor || (CardsGalleryPlusHeadlineColor = {}));
var CardsGalleryPlusHeadlineSize;
(function (CardsGalleryPlusHeadlineSize) {
    CardsGalleryPlusHeadlineSize["SMALL"] = "small";
    CardsGalleryPlusHeadlineSize["MEDIUM"] = "medium";
    CardsGalleryPlusHeadlineSize["LARGE"] = "large";
})(CardsGalleryPlusHeadlineSize || (CardsGalleryPlusHeadlineSize = {}));
var CardsGalleryPlusHeadlineAlign;
(function (CardsGalleryPlusHeadlineAlign) {
    CardsGalleryPlusHeadlineAlign["LEFT"] = "left";
    CardsGalleryPlusHeadlineAlign["CENTER"] = "center";
    CardsGalleryPlusHeadlineAlign["RIGHT"] = "right";
})(CardsGalleryPlusHeadlineAlign || (CardsGalleryPlusHeadlineAlign = {}));
var CardsGalleryPlusTitleColor;
(function (CardsGalleryPlusTitleColor) {
    CardsGalleryPlusTitleColor["BLACK"] = "black";
    CardsGalleryPlusTitleColor["PURPLE"] = "purple";
    CardsGalleryPlusTitleColor["BURGUNDY"] = "burgundy";
})(CardsGalleryPlusTitleColor || (CardsGalleryPlusTitleColor = {}));
var CardsGalleryPlusCardBackground;
(function (CardsGalleryPlusCardBackground) {
    CardsGalleryPlusCardBackground["GREY"] = "grey";
    CardsGalleryPlusCardBackground["WHITE"] = "white";
    CardsGalleryPlusCardBackground["NIGHT"] = "night";
    CardsGalleryPlusCardBackground["BURGUNDY"] = "burgundy";
    CardsGalleryPlusCardBackground["PURPLE"] = "purple";
})(CardsGalleryPlusCardBackground || (CardsGalleryPlusCardBackground = {}));
var CardsGalleryPlusButtonType;
(function (CardsGalleryPlusButtonType) {
    CardsGalleryPlusButtonType["PRIMARY"] = "primary";
    CardsGalleryPlusButtonType["SECONDARY"] = "secondary";
    CardsGalleryPlusButtonType["TERTIARY"] = "tertiary";
})(CardsGalleryPlusButtonType || (CardsGalleryPlusButtonType = {}));

export { CardsGalleryPlusButtonType, CardsGalleryPlusCardBackground, CardsGalleryPlusDisplayType, CardsGalleryPlusHeadlineAlign, CardsGalleryPlusHeadlineColor, CardsGalleryPlusHeadlineSize, CardsGalleryPlusTemplateType, CardsGalleryPlusTitleColor };
